/**
 * Dashboard adapters for `@aimsos/ui`'s WidgetGrid (CT-5273).
 *
 * These are NOT shaped like the rest of this folder, and that is deliberate:
 * their signatures and return shapes are fixed by the package
 * (`services/defaultDataAdapters.js`), so the adaptation happens here, at the
 * edge, rather than bending the package to the platform envelope.
 *
 * Everything else is unchanged — real `snake_case` bodies, the same transport
 * seam, the same one-flag cutover.
 */

import { validateApiResponse } from '../shared/utils/apiResponse.js';
import { request } from './mockTransport.js';

export { __resetMockDashboardsForTests } from './__mocks__/dashboards.mock.js';

/**
 * Dashboards published against an entity type, for one module.
 *
 * Contract: `(scopeType, module) => Promise<{ data: Dashboard[] }>`.
 *
 * TODO(CT-5273 / backend): `POST /v1/workspace/profiles/dashboards/list`.
 */
export const fetchDashboardList = async (scopeType, module) => {
  const response = await request('/v0/profile/dashboards/list', {
    scope_type: scopeType,
    module,
  });
  const { body } = validateApiResponse(response, 'Failed to load dashboards');
  return { data: body?.items ?? [] };
};

/**
 * The widget layout of one dashboard.
 *
 * Contract: `(dashboardUuid, options?) => Promise<{ data: DashboardLayout }>`,
 * where `options.signal` is an AbortSignal the grid uses to cancel in-flight
 * loads when the user switches dashboards.
 *
 * TODO(CT-5273 / backend): `POST /v1/workspace/profiles/dashboards/layout`.
 */
export const fetchDashboardLayout = async (dashboardUuid, options = {}) => {
  options.signal?.throwIfAborted?.();
  const response = await request('/v0/profile/dashboards/layout', {
    dashboard_uuid: dashboardUuid,
  });
  const { body } = validateApiResponse(response, 'Failed to load the dashboard layout');
  return { data: body };
};
